export default "__VITE_ASSET__CA0S3BV2__"